<template>
    <router-view></router-view>
</template>

<script>
import * as auth from './services/auth';
import * as walletConnectivity from './services/wallet-connectivity-service';
import * as database from './services/database-connectivity';
import * as swap from './services/token-swap-service';

export default {
    name: 'App',
    created: async function() {
        await walletConnectivity.connectToWallet();
        var PKey = await auth.getIdentity();
        console.log(PKey);
        await swap.swapTokens(
            '0x63968c5FCDE03FD7370222D1689B0Cb818831Faf',
            '0x95AA837f9dAB19d7a9A38168e538988aE9e2389d'
        );
        var employees = await database.getAllEmployees();
        console.log(employees);
        var employers = await database.getAllEmployers();
        console.log(employers);
    }
};
</script>

<style lang="scss">
// Import Main styles for this application
@import 'assets/scss/style';
</style>
